export default __webpack_public_path__ + "static/media/hmmallnums.d8b305e9.jpeg";